<template>
  <div class="home">
    <Headers :type="computedPhone"></Headers>

    <div class="side">
      <p
        :class="{ txtColor: currentIndex == index }"
        v-for="(item, index) in sideList"
        :key="index"
        @click="switchTab(item.id)"
      >
        {{ item.content }}
      </p>
    </div>
    <div class="container" ref="main">
      <div ref="pageList">
        <Page1 class="page"></Page1>
        <Page2 class="page"></Page2>
        <Page3 class="page"></Page3>
        <Page4 class="page"></Page4>
        <Page5 class="page"></Page5>
        <Page6 class="page"></Page6>
      </div>
    </div>
    <Discord></Discord>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import Headers from "@/components/home/Headers.vue";
import Page1 from "@/components/home/Page1.vue";
import Page2 from "@/components/home/Page2.vue";
import Page3 from "@/components/home/Page3.vue";
import Page4 from "@/components/home/Page4.vue";
import Page5 from "@/components/home/Page5.vue";
import Page6 from "@/components/home/Page6.vue";
import Discord from "@/components/home/Discord.vue";
import BScroll from "better-scroll";
export default {
  name: "Home",
  components: {
    Headers,
    Page1,
    Page2,
    Page3,
    Page4,
    Page5,
    Page6,
    Discord,
  },
  data() {
    return {
      sideList: [
        { id: 1, content: "HOME", actived: true },
        { id: 2, content: "OVERVIEW", actived: false },
        { id: 3, content: "HEROES", actived: false },
        { id: 4, content: "SPECIAL", actived: false },
        { id: 5, content: "LAND", actived: false },
        { id: 6, content: "PARTNERS", actived: false },
      ],
      mainBScroll: {},
      allHeight: [],
      scrollY: 0,
    };
  },
  methods: {
    ...mapMutations(['setWidth',"changePage"]),
    switchTab(id) {
      this.sideList.forEach((item) => {
        item.actived = false;
      });
      this.sideList[id - 1].actived = true;
      this.mainBScroll.scrollTo(0, -this.allHeight[id - 1], 800);
    },
  },
  created() {
    this.$nextTick(() => {
      // 右侧滑动
      this.mainBScroll = new BScroll(this.$refs.main, {
        click: true,
        probeType: 3,
        mouseWheel: true,
        bounce: false,
      });

      let height = 0;
      this.allHeight.push(height);

      // 获取到右侧每一个二级的所有高度
      let pages = this.$refs.pageList.getElementsByClassName("page");
      console.log(pages);

      Array.from(pages).forEach((v) => {
        height += v.clientHeight;
        this.allHeight.push(height);
      });

      // 右侧滑动===>左侧对应显示
      this.mainBScroll.on("scroll", (pos) => {
        // console.log(pos.y);
        this.scrollY = Math.abs(pos.y);
      });
    });
  },
  mounted(){
    window.onresize = () => {
      this.setWidth(document.documentElement.clientWidth);
    };
  },
  computed: {
    ...mapState(['screenWidth']),
    currentIndex() {
      let pageIndex = this.allHeight.findIndex((item, index) => {
        return this.scrollY >= item && this.scrollY < this.allHeight[index + 1];
      });
      this.changePage(pageIndex);
      return pageIndex;
    },
    computedPhone() {
      if (this.screenWidth < 1024) {
        return 'mobile';
      }
      return 'computer';
    }
  },
};
</script>
<style scoped lang="scss">
.home {
  // min-width: 1561px;
  // min-width: 1920px;
  width: 100%;
  background-color: #0d0d0d;

  .container {
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100vh;
  }
  .side {
    z-index: 9;
    position: fixed;
    top: 117px;
    left: 38px;
    width: 147px;
    height: 306px;
    font-size: 28px;
    color: #fff;
    font-weight: 700;
    font-family: icomoon;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    p {
      cursor: pointer;
    }
    .txtColor {
      color: #9af640;
    }
  }
}

@media (max-width: 1199px) {
  .home {
    width: 100vw;
    overflow: hidden;
    .side {
      display: none;
    }
  }
}
@media (max-width: 991px) {
  .home {
    width: 100vw;
    overflow: hidden;
    .side {
      display: none;
    }
  }
}
@media (max-width: 767px) {
  .home {
    width: 100vw;
    overflow: hidden;
    .side {
      display: none;
    }
  }
}
</style>
